module.exports = __webpack_public_path__ + "img/logo_horizontal_white.b2aa4d60.svg";